import { ButtonHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from './index.styles';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  view: CalendarView;
}

export const CreationButton = (props: Props) => {
  const { t } = useTranslation('calendar');

  return (
    <Container
      data-testid="calendar-create-new-button"
      className="creation-button"
      data-export-hide
      tabIndex={-1}
      $view={props.view}
      {...props}
    >
      <p>+ {t('new_post')}</p>
    </Container>
  );
};
